<template>
  <div>
    <el-dialog title="富信" custom-class="" :visible.sync="visible"  :before-close="handleClose" 
    :width="isMediaQualification?'1050px':'800px'">
      <div>
        <div class="sms-content"  :style="{ 'margin-bottom':isMediaQualification ? '190px' : '' }">
          <section class="main">
            <el-form ref="formSearch" class="sms-box" :modle="formData" :disabled="isReadOnly" label-width="80px">
              <el-form-item required label="节点名称" style="position: relative;">
                <div class="name-wrap">
                  <el-input class="name-wrap-input" v-model="formData.name" show-word-limit maxlength="50"></el-input>
                  <div class="name-wrap-setName" @click="setName">智能命名</div>
                </div>
              </el-form-item>
              <el-form-item required label="富信模板" v-loading="editLoading">
                <!-- <div v-if="isMediaQualification"> -->
                  <div v-if="isMediaQualification" class="fx_btn">
                    <el-select v-model="mediaId" @change="changeMedia"  filterable >
                      <el-option v-for="(item, index) in mediaOptionList" :key="index" :value="item.id"
                        :label="item.name"></el-option>
                    </el-select>
                    <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addMediaModule">添加模板</span>
                  </div>
                  <div v-else>
                  <div class="notShow">
                    <img src="@/assets/images/未开通富信.png" alt="">
                    <p>您还未开通富信营销功能</p>
                    <div class="bottom-btn">
                      <button class="select" style="width: 136px;" @click.prevent="checkOut">
                        查看富信营销案例
                      </button>
                      <button class="keep" style="width: 150px;" @click.prevent="toSubmit">
                        去提交资质申请开通
                      </button>
                    </div>
                  </div>
                  <sms-info-template v-if="smsInfoTemplateShow" @close="handleCloseSmsInfo1" :isShow="smsInfoTemplateShow" />
                </div>
                <!-- </div> -->
                <!-- <rich-message v-model="richMessageData" :returnData="returnData" /> -->
              </el-form-item>
              <div v-if="isMediaQualification">
                <el-form-item label="短信签名">
                  <div class="btnList">
                    <div class="btnBox" v-for="(item, index) in suffixList" :key="'label' + index"
                      @click.prevent="switchSuffix(index)" style="margin-bottom:5px">
                      <button class="btn">{{ item }}</button>
                      <span class="check" v-if="formData.jdSmsSuffix === item">
                        <i class="el-icon-check"></i>
                      </span>
                    </div>
                    <span style="font-size: 14px; cursor: pointer" class="btnListButtom" @click="replaceSignature">更换</span>
                  </div>
                </el-form-item>
                <el-form-item label="过滤设置:">
                  <el-checkbox :label="true" v-model="formData.filtrationBlacklistFlag">
                    过滤黑名单人群
                    <span @click.stop="toBlack" style="color: #7f85e9; margin-left: 8px">设置黑名单</span>
                  </el-checkbox>
                  <el-checkbox :label="true" v-if="isPremissionShow" v-model="formData.filterAlreadySentFlag">
                    <span>屏蔽近</span>
                    <el-input v-model.number="formData.filterDays" @keyup.native="limitInput($event)"
                      onblur="value=value.replace(/[^\d]/g,'')" style="width: 100px; padding: 0 6px">
                    </el-input>
                    <span>天已发送客户</span>
                  </el-checkbox>
                </el-form-item>
              <!-- 添加发送限制人数  v-if="sendType == '1'"-->
              <el-form-item label="发送人数:" >
              <div>
                <el-radio-group v-model="formData.sendIntType" @change="handleSendType">
                  <el-radio :label="0">不限</el-radio>
                  <el-radio :label="1">限制发送数</el-radio>
                </el-radio-group>
                <el-input v-model="formData.smsLimit" placeholder="填写发送数" style="width: 120px; margin-left: 8px"
                  :disabled="formData.sendIntType === 0" @keyup.native="
                    formData.smsLimit = oninput(formData.smsLimit)
                  " @change="sendPeopleChange"></el-input>
               </div>
             </el-form-item>
             <!-- end -->
                <el-form-item label="短信测试:" class="smsTest">
                  <div class="test">
                    <!-- 需开启富信测试后才可选择测试手机号 -->
                    <!-- <el-checkbox v-model="isRichSmsTest" style="margin-right: 10px;">富信测试</el-checkbox> -->
                    <el-select v-model="mediaTestMobilesList" multiple collapse-tags placeholder="请选择"
                      style="width: 264px;vertical-align: top;" @change="selectMediaTestMobiles" >
                      <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                    <el-button style="margin-left: 8px;" class="record1" @click="sendRichTest">发送测试短信</el-button>
                    <el-button class="record" style="margin-right: 0px;" @click="smsDialogs = true">短信记录</el-button>
                    <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="updataPhone">修改测试手机号</span>
                  </div>
                  <div class="info">
                    <i class="el-icon-warning warning-icon"></i>
                    <p>注：短信测试号码为申请签名时报备的号码,且发送测试短信不受频控限制。</p>
                    
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </section>
        </div>
        <div class="xiao-hug xiao_hug2" v-if="isMediaQualification">
          <div>
            <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">  
              <sms-info-body v-if="mediaId && preMediaShow" :key="mediaId" :title="smsInfoRowData.title" :text="smsInfoRowData.text" :mediaListJsonArray="smsInfoRowData.mediaList"></sms-info-body>
            </div>
            <div class="mobile-tips">富信预览效果</div>
          </div>
        </div>
        <div class="dialog-footer-btn" v-if="isMediaQualification">
          <el-button class="reset" @click="handleClose">取消</el-button>
          <el-button class="search" v-loading="updateLoading" :disabled="updateLoading || isReadOnly"
            @click="handleConfirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 富信选择模板 -->
    <myPopup title="选择模板" :flag="selectTempleteShowDialog" :zIndex="'4000'" :width="'800'" @close="chooseTemplate(null, 1)"
      style="margin-top: -50px;">
      <div class="selectTemplet">
        <el-table v-loading="tableLoading" :data="selectTemplateData"
          style="width: 100%;border: 1px solid #e6e6e6;text-align: center;">
          <el-table-column prop="name" label="模板名称"></el-table-column>
          <el-table-column label="模板内容">
            <template slot-scope="scope">
              <span style="color: #FE4D45;cursor: pointer;" @click="showTemplateInfo(scope.row)">{{ scope.row.title
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="最后一次修改时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span style="color: #FE4D45;cursor: pointer;" @click="chooseTemplate(scope.row)">选择</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: right;margin-top: 28px;">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleTemplateCurrentChange"
          :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
          :total="templatePaginationInfo.total" :page-size="templatePaginationInfo.size"
          :current-page="templatePaginationInfo.current" style="text-align: right; margin-top: 20px;">
        </el-pagination>
      </div>
    </myPopup>
    <!-- 富信保存模板 -->
    <myPopup title="保存模板" :flag="richkeepTmpShow" :zIndex="'4000'" @close="handleCloseTmp">
      <div class="selectBox1">
        <div class="headCnt">
          <span><span style="color:red;">*</span> 模板名称：</span>
          <el-input v-model="richtemplateName" style="width: 350px;" maxlength="15" show-word-limit>
          </el-input>
        </div>
        <el-button @click="handleCloseTmp(1)">保存模板</el-button>
      </div>
    </myPopup>
    <!-- 短信内容预览 -->
    <sms-info v-if="smsInfoShow" @close="handleCloseSmsInfo" :isShow="smsInfoShow" :id="smsInfoRowData.contentId"
      :title="smsInfoRowData.title" :text="smsInfoRowData.text" />
    <!-- 短信记录 -->
    <sms-template2 :smsDialog="smsDialogs" v-if="smsDialogs" :isMedia="true" @transferName="transferName"
      @close="smsDialogClose"></sms-template2>
    <!-- 修改号码弹窗 -->
    <el-dialog title="修改测试短信号码" :visible.sync="showDialogOne" width="460px" style="min-width: 1100px">
      <template slot="title">
        <span>修改测试短信号码</span>
      </template>
      <div class="dialog-wrapper">
        <!-- <div class="item">
          <span class="item-title">短信测试：</span>
          <el-input size="small" class="input" v-model="testMobiles"></el-input>
        </div> -->
        <div class="remarks">
          <div>请前往【京东云舟】-【工具】-【短信工具】-【短信签名】中进行修改号码中操作</div>
          <!-- 注：填写测试号码，在测试发送时无需审核短信内容。 -->
          <!-- <div>1、测试短信手机号不受频控限制，最多填写15个，多个之间用英文逗号分隔；</div>
          <div>2、修改完成后立即生效，且测试手机号的修改会应用到全部渠道；</div>
          <div>3、每天修改手机号的次数上限为5次；</div> -->
        </div>
        <div></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button showDialog="showDialog" style="width: 96px" @click="showDialogOne = false">关闭</el-button>
        <!-- <el-button showDialog="showDialog" style="width: 96px" @click="showDialogOne = false">取消</el-button>
        <el-button @click="mobilPhoneSubmit" type="primary" style="width: 96px">提交</el-button> -->
      </span>
    </el-dialog>
    <sendTestMediaConfirm 
      v-if="sendTestMediaConfirmShow"
      @close="sendTestMediaConfirmShow = false" 
      @confirm="sendTestMediaConfirmShow = false"
      :source="3"
      :mediaTestMobilesList="mediaTestMobilesList"
      :id="mediaId"
      :mediaTemplateId="mediaTemplateId">
    </sendTestMediaConfirm>
  </div>
</template>
  
<script>

import mnode from "@/api/intelligentMarket/a_node";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { getValidSmsTestMobiles,getMediaList } from "@/api/smsSend";
import { getSmsMediaTemplate, getSmsMediaTemplateDetail, smsMediaTemplateSave } from "@/api/smsTemplates";
import { updateSuffixMobileById } from "@/api/backstage/messageBill";
import sendTestMediaConfirm from '@/components/sendTestMediaConfirm';
import { getSeller } from "@/api/richSms";
// 短信记录模板
import smsTemplate2 from "@/components/sms-templates-x-drawer.vue";
// 富信组件
import richMessage from "@/components/rich-message";
import smsInfo from "@/components/sms-info";
import smsInfoTemplate from "@/components/sms-info-template";
import myPopup from "@/components/myPopup";
import smsInfoBody from "@/components/sms-info-body";

export default {
  name: "",
  data() {
    return {
      editLoading: true,
      mobileScreen: require("@/assets/images/mobileScreen.png"),
      preMediaShow:false,
      smsInfoTemplateShow:false,
      sendTestMediaConfirmShow:false,
      isMediaQualification:false,
      mediaId:null,
      mediaId2:null,
      mediaTemplateId:null,
      mediaOptionList:[],
      isPremissionShow: false, // 屏蔽近X天发送客户的权限
      formData: {
        nodeId: "",
        name: "",
        content: "",
        jdSmsSuffix: "",
        jdShortLink: "",
        realUrl: '',
        filtrationBlacklistFlag: false,
        filterAlreadySentFlag: false,
        filterDays: '',
        mediaContent: {
          mediaTitle: "",
        },
        mediaTestMobiles: '',
        sendIntType:0,
        smsLimit:''
      },
      TTip: '拒收请回复R',
      suffixList: [],
      updateLoading: false,
      smsDialogs: false,
      richMessageData: {}, // 富信数据
      // isRichSmsTest: true, // 是否启用 富信测试 
      testOptions: [], // 获取测试手机号
      textPhoneId: '', // 修改测试手机号id
      mediaTestMobilesList: [], // 选中的测试手机号列表
      showDialogOne: false, // 修改测试手机号弹窗
      mobilPhone: '', // 测试手机号
      testMobiles: '', // 修改测试手机号
      selectTempleteShowDialog: false, // 富信选择模板
      richkeepTmpShow: false, // 富信保存模块弹窗
      smsInfoShow: false, // 短信预览弹窗
      smsInfoRowData: {}, // 短信详情数据
      selectTemplateData: [],// 选择模板
      mediaTemplateForm: {  // 富信选择模板列表查询
        size: 10,
        current: 1
      },
      templatePaginationInfo: {  // 选择模板分页器
        current: 1,
        size: 10,
        total: 2
      },
      richtemplateName: '', // 富信保存模板名称
      returnData: {
        totalSize: 0, // 总大小
        mediaTitle: "", // 短信标题
        content: '', // 文本内容
        mediaList: [], // 富媒体列表
        jdSmsSuffix: '', // 短信签名
        sourceUrl: '', // 原链接
        jdShortLink: '' // 短链接
      }, // 富信回显
      tableLoading: false,
      mediaFlag: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    richMessage,
    smsInfo,
    smsInfoTemplate,
    smsTemplate2,
    myPopup,
    sendTestMediaConfirm,
    smsInfoBody
  },
  mounted() {
    this.formData.nodeId = this.nodeId;
    this.getSuffixList();
    this.handleShowPremission();
    // 获取当前节点详情
    mnode
      .getNode({
        nodeId: this.nodeId,
      })
      .then((res) => {
        if (res.code == "1") {
          console.log(res.data);
          this.formData.name = res.data.name;
          var smsNode = res.data.smsNode;
          if (smsNode.content && smsNode.content.indexOf('拒收请回复R') != '-1') {
            smsNode.content = smsNode.content.substr(0, smsNode.content.length - 6)
          }
          this.mediaId2 = smsNode.mediaTemplateId
          this.returnData.content = smsNode.content || '';
          this.returnData.jdShortLink = smsNode.jdShortLink || '';
          this.returnData.sourceUrl = smsNode.realUrl || '';
          this.returnData.jdSmsSuffix = smsNode.jdSmsSuffix || '';
          this.returnData.mediaTitle = smsNode.mediaContent ? smsNode.mediaContent.mediaTitle || "" : '';
          this.returnData.mediaList = smsNode.mediaContent ? smsNode.mediaContent.mediaList || [] : [];
          this.formData.filtrationBlacklistFlag = smsNode.filtrationBlacklistFlag ? true : false
          this.formData.filterAlreadySentFlag = smsNode.filterAlreadySentFlag ? true : false
          this.formData.filterDays = smsNode.filterDays
          if(smsNode.smsLimit){
           this.formData.sendIntType = 1
           this.formData.smsLimit = smsNode.smsLimit
          }else{
            this.formData.sendIntType = 0
            this.formData.smsLimit = '';
          }
          if (smsNode.mediaTestMobiles) {
            // this.isRichSmsTest = true
            this.mediaTestMobilesList = smsNode.mediaTestMobiles.split(',')
            this.formData.mediaTestMobiles = smsNode.mediaTestMobiles
          }else{
            // this.isRichSmsTest = false
          }
          // if (smsNode.filtrationBlacklistFlag) {
          //   this.formData.filtrationBlacklistFlag = true
          // }
          // if (smsNode.jdSmsSuffix) {
          //   this.formData.jdSmsSuffix = smsNode.jdSmsSuffix;
          //   this.richMessageData.jdSmsSuffix = smsNode.jdSmsSuffix;
          // }
          // if (smsNode.filterAlreadySentFlag) {
          //   this.formData.filterAlreadySentFlag = smsNode.filterAlreadySentFlag;
          // }
        }
      });
    // 获取测试手机号
    getValidSmsTestMobiles().then(res => {
      if (res.code == 1) {
        this.testOptions = res.data.smsTestMobiles
        this.testMobiles = res.data.smsTestMobiles.join(',')
        this.textPhoneId = res.data.id
      }
    })
    getSeller().then(res => {
      this.editLoading = false;
      if (res.code == 1) {
        this.isMediaQualification = res.data.isMediaQualification
        if(this.isMediaQualification){
          this.getMediaOption('');
        }
      }
    }).catch(res => {this.editLoading = false;});
    // this.getMediaOption('');
  },
  computed: {
    viewVisible: {
      get: function () {
        return this.visible
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit('update:visible', true)
        } else {
          this.$emit('update:visible', false)
        }
      }
    },
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
  },
  watch: {
    permissions(nVal, oVal) {
      if (nVal.indexOf('hide:filter:send') != '-1') {
        // 显示屏蔽发送按钮
        this.isPremissionShow = true;
      }
    },
    'formData.smsType': {
      handler(nVal) {
        // console.log('短信类型',nVal);
        if (nVal == 0) {
          this.clearBuriedPoint()
        } else {
          if (this.sendType == 2) {
            this.buriedPoint(2, '智能营销/富信', "客户营销", "精准营销")
          }
        }
      },
      immediate: true,
    }
  },
  methods: {
    // 查看富信营销案例
    checkOut() {
      this.smsInfoTemplateShow = true
    },
    // 关闭富信营销案例弹窗
    handleCloseSmsInfo1() {
      this.smsInfoTemplateShow = false
    },
    // 提交资质申请开通
    toSubmit() {
      // 跳转至  后台管理-富信资质
      this.$router.push({ name: 'media_qualification' })
    },
    addMediaModule(){
      let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_module",
        query: { type: "5" },
      });
      window.open(routeUrl.href, "_blank");
    },
    getMediaOption(name){
      getMediaList({name}).then(res=>{
        if(res.code == 1){
          this.mediaOptionList = res.data
          if(this.mediaId2){
            let row = this.mediaOptionList.find(o=>o.mediaTemplateId == this.mediaId2)
            this.mediaId = row.id
            this.changeMedia();
          }
        }else{
          this.$message.error(res.message)
        }
      })
    },
    remoteMethod(name){
      getMediaList({name}).then(res=>{
        if(res.code == 1){
          this.mediaOptionList = res.data
        }else{
          this.$message.error(res.message)
        }
      })
    },
     // 富信测试
    sendRichTest(){
      if( !this.mediaId){
        this.$message.warning("请选择富信模板");
        return;
      }
      if(this.mediaTestMobilesList && this.mediaTestMobilesList.length > 0){
        this.sendTestMediaConfirmShow = true;
      }else{
        this.$message.warning('请输入正确的手机号！');
        return 
      }
    },
    changeMedia(){
      let row = this.mediaOptionList.find(o=>o.id == this.mediaId)
      this.mediaTemplateId = row.mediaTemplateId
      this.preMediaShow = false;
      getSmsMediaTemplateDetail(this.mediaId).then(res => {
        if (res.code == 1) {
          let data = res.data
          this.returnData.mediaTitle = data.title
          this.returnData.totalSize = data.totalSize
          this.returnData.content = data.text
          this.returnData.mediaList = data.mediaList
          this.returnData.sourceUrl = data.originUrl
          this.returnData.jdShortLink = data.jdShortLink

          this.richMessageData.mediaTitle = data.title
          this.richMessageData.totalSize = data.totalSize
          this.richMessageData.content = data.text
          this.richMessageData.mediaList = data.mediaList
          this.richMessageData.sourceUrl = data.originUrl
          this.richMessageData.jdShortLink = data.jdShortLink
          this.smsInfoRowData = res.data
          this.preMediaShow = true;
        }
      })
    },
    // 不可输入小数
    oninput(val) {
      return val ? val.replace(/\D/g, "") : "";
    },
    // 发送限制数
    handleSendType(val) {
      this.formData.smsLimit = "";
    },
    // 发送人数的限制
    sendPeopleChange(val) {
      if (val == 0) {
        this.formData.smsLimit = "";
        this.$message.warning("人数只能输入正整数");
      } 
    },
    // 智能命名
    setName(){
      mnode.getAutoName(this.nodeId).then(res=>{
        console.log(res);
        if(res.code){
          this.formData.name = res.data
        }else if (res.code == undefined && res.data.code === 0){
          this.$message.warning(res.data.message)
        }
      })
    },
    handleShowPremission() {
      // 按钮权限显示
      if (this.permissions && this.permissions.indexOf('hide:filter:send') != '-1') {
        // 显示屏蔽发送按钮
        this.isPremissionShow = true;
      }
    },
    limitInput(event) {
      if (event.target.value == '0') {
        event.target.value = ''
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, '')
      }
    },
    getSuffixList() {
      var type = '2'
      getPrecisionJdSuffixList(type).then(res => {
        if (res.code == "1") {
          this.suffixList = res.data;
          if (!this.formData.jdSmsSuffix) {
            this.formData.jdSmsSuffix = this.suffixList[0] || "";
            this.returnData.jdSmsSuffix = this.suffixList[0] || "";
          }
        }
      })
    },
    handleClose() {
      this.viewVisible = false;
    },
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    // 提交
    handleConfirm() {
      // 节点名称
      if(!this.formData.name){
        return this.$message.error("节点名称不能为空")
      }
      if(!this.mediaId){
        return this.$message.error("富信模板不能为空")
      }
      if(this.formData.filterAlreadySentFlag && !this.formData.filterDays){
        return this.$message.error("屏蔽已发送客户天数不能为空")
      }
      if(this.formData.sendIntType == 1 && !this.formData.smsLimit){
        return this.$message.error("限制发送数不能为空")
      }
      this.formData.content = this.richMessageData.content
      this.formData.totalSize = this.richMessageData.totalSize
      this.formData.mediaContent.mediaTitle = this.richMessageData.mediaTitle
      this.formData.mediaContent.mediaList = this.richMessageData.mediaList
      this.formData.mediaContent.jdShortLink = this.richMessageData.jdShortLink
      this.formData.realUrl = this.richMessageData.sourceUrl
      // if (this.isRichSmsTest && !this.formData.mediaTestMobiles) {
      //   console.log(this.formData.mediaTestMobiles);
      //   this.$message.info("请选择测试手机号");
      //   return
      // }
      console.log(this.formData);
      // if (this.isRepeat(this.formData.content.match(/3\.cn/g))) {
      //   this.$message.warning("官方插入的短链接不允许超过1个哦！");
      //   return;
      // }
      var param = JSON.parse(JSON.stringify(this.formData))
      // if(!this.isRichSmsTest) param.mediaTestMobiles = ""
      if (param.jdShortLink) {
        if (param.content.indexOf("#自定义短链#") == '-1') {
          param.jdShortLink = '';
          param.realUrl = '';
        }
      }
      // param.content = param.content + this.TTip;
      this.updateLoading = true;
      if(param.sendIntType==0){
        param.smsLimit = ''
      }
      param.mediaTemplateId = this.mediaTemplateId
      // 测试手机号
      if(this.mediaTestMobilesList && this.mediaTestMobilesList.length){
        param.mediaTestMobiles = this.mediaTestMobilesList.join(',')
      }
      mnode.updateMediumDetail(param).then((res) => {
        this.updateLoading = false;
        if (res.code === 1) {
          this.$message.success("保存成功！");
          this.viewVisible = false;
          this.$emit('change-name', param)
        } else {
          this.$message.error(res.message)
        }
      });
    },
    // 富信测试手机号 
    selectMediaTestMobiles(val) {
      this.formData.mediaTestMobiles = this.mediaTestMobilesList.join(',')
    },
    // 选择模板 打开
    selectTempleteShow() {
      this.selectTempleteShowDialog = true
      this.tableLoading = true
      let params = {
        size: this.templatePaginationInfo.size,
        current: this.templatePaginationInfo.current
      }
      getSmsMediaTemplate(params).then(res => {
        if (res.code == 1) {
          this.templatePaginationInfo.total = res.data.total
          this.selectTemplateData = res.data.records
          this.tableLoading = false
        }
      })
    },
    // 选择模板 关闭
    chooseTemplate(val, close) {
      if (close == 1) {
        this.selectTempleteShowDialog = false
        return
      }
      getSmsMediaTemplateDetail(val.id).then(res => {
        if (res.code == 1) {
          let data = res.data
          this.returnData.mediaTitle = data.title
          this.returnData.totalSize = data.totalSize
          this.returnData.content = data.text
          this.returnData.mediaList = data.mediaList
          this.returnData.sourceUrl = data.originUrl
          // 模板名称
          this.richtemplateName = data.name
          this.selectTempleteShowDialog = false
        }
      })
    },
    // 选择模板分页器
    handleTemplateCurrentChange(val) {
      this.templatePaginationInfo.current = val
      this.selectTempleteShow()
    },
    // 选择模板分页器
    handleSizeChange(val) {
      this.templatePaginationInfo.size = val
      this.selectTempleteShow()
    },
    // 查看短信内容
    showTemplateInfo(val) {
      getSmsMediaTemplateDetail(val.id).then(res => {
        if (res.code == 1) {
          this.smsInfoRowData = res.data
          this.smsInfoRowData.contentId = val.mediaMulitiFileId
          this.smsInfoShow = true
        }
      })
    },
    // 关闭短信内容弹窗
    handleCloseSmsInfo() {
      this.smsInfoShow = false
    },
    // 保存模板 显示
    handleShowModule1() {
      this.richkeepTmpShow = true;
    },
    // 保存模板隐藏
    handleCloseTmp(val) {
      if (val == 1) {
        if (!this.richtemplateName) {
          this.$message({ message: '请输入模板名称', type: 'warning' });
          return false
        }
        if (!this.richMessageData.mediaTitle) {
          this.$message({ message: '请输入富信标题', type: 'warning' });
          return false
        }
        if (!this.richMessageData.content) {
          this.$message({ message: '请输入富信内容', type: 'warning' });
          return false
        }
        // if (!this.richMessageData.sourceUrl) {
        //   this.$message({ message: '请插入短链接', type: 'warning' });
        //   return false
        // }
        let params = {
          name: this.richtemplateName,
          title: this.richMessageData.mediaTitle,
          text: this.richMessageData.content,
          originUrl: this.richMessageData.sourceUrl,
          mediaList: this.richMessageData.mediaList,
          totalSize: this.richMessageData.totalSize
        }
        smsMediaTemplateSave(params).then((res) => {
          if (res.code == "1") {
            this.$message.success({ message: "保存模板成功！", customClass: 'message-zindex' });
            this.richkeepTmpShow = false
          } else {
            this.$message.error({ message: res.message, customClass: 'message-zindex' });
          }
        })
      } else {
        this.richkeepTmpShow = false;
      }
    },
    // 修改测试手机号弹窗
    updataPhone() {
      this.showDialogOne = true
    },
    // 修改测试手机号确认弹窗
    mobilPhoneSubmit() {
      updateSuffixMobileById({
        smsTestMobiles: this.testMobiles,
        id: this.textPhoneId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.mediaTestMobilesList = [];
            this.getVal();
            this.showDialogOne = false
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => { })
        .finally(() => {
          
        });
    },
    getVal() {
      // 获取测试手机号
      getValidSmsTestMobiles().then(res => {
        if (res.code == 1) {
          this.testOptions = res.data.smsTestMobiles
          this.testMobiles = res.data.smsTestMobiles.join(',')
          this.textPhoneId = res.data.id
        }
      })
    },
    // 切换签名
    switchSuffix(index) {
      this.selectSuffix = this.suffixList[index];
      this.formData.jdSmsSuffix = this.selectSuffix || "";
      this.returnData.jdSmsSuffix = this.selectSuffix || ""
    },
    smsDialogClose(data) {
      // console.log(data, 111);
      this.smsDialogs = data;
    },
    transferName() {
      this.smsDialogs = false;
    },
    replaceSignature() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },
    toBlack() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
  
<style scoped lang="scss">
::v-deep .el-dialog__wrapper{
  background: rgba(0,0,0,0.5);
}
.xiao_hug2 {
  position: absolute;
  top: 50px;
  left: 755px;
  .mobile-box {
      position: relative;
      width: 256px;
      margin-top: 21px;
      height: 504px;

      // background: url("../../assets/images/mobileScreen.png") no-repeat;
      .message-content {
        position: absolute;
        word-wrap: break-word;
        max-height: 250px;
        overflow-y: auto;
        padding: 12px 12px;
        border-radius: 6px;
        width: 210px;
        font-size: 14px;
        background-color: #fafafa;
        line-height: 20px;
        left: 50%;
        margin-left: -104.665px;
        text-align: left;
        top: 25.4%;
      }
  }
  .mobile-tips {
    margin-top: 16px;
    font-size: 16px;
    text-align: center;
  }
}

.notShow {
  position: relative;

  img {
    margin-left: 100px;
    width: 348px;
    height: 348px;
  }

  p {
    position: absolute;
    left: 197px;
    top: 328px;
    color: #999999;
    font-size: 14px;
  }

  .bottom-btn {
    width: 560px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .select {
  width: 98px;
  height: 32px;
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  border-radius: 3px;
  background-color: #fff4f4;

  &:hover {
    color: #fe4d45;
    background-color: #ffe5e5;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.keep {
  width: 98px;
  height: 32px;
  margin: 0 10px 0 8px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
  border: 1px solid #fe4d45;
  background-color: #fe4d45;

  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
}
.btnListButtom {
    color: rgb(127, 133, 233);

    &:hover {
      color: #fe4d45;
    }
  }
.sms-content {
  position: relative;
}

.btnList {
  display: flex;
  align-items: center;
  height: 32px;

  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    cursor: pointer;
  }

  .btnListButtom {
    color: rgb(127, 133, 233);

    &:hover {
      color: #fe4d45;
    }
  }

  .btnBox {
    position: relative;
    overflow: hidden;
    height: 31px;
    margin-right: 16px;

    .btn {
      padding: 5px 12px;
      height: 31px;
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      cursor: pointer;
    }

    .check {
      position: absolute;
      right: -16px;
      bottom: -15px;
      width: 30px;
      height: 30px;
      background-color: #fe4d45;
      border-radius: 50%;
    }

    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }
}


.sms-box {
  width: 680px;
}


.dialog-footer-btn {
  text-align: center;
  // margin-top: 110px;
  padding-left: 280px;

  .search {
    width: 98px;
    height: 32px;
    color: #ffffff;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .reset {
    width: 98px;
    height: 32px;
    color: #666666;
    font-size: 14px;
    margin: 32px 0px 0 490px;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;

    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

.fx_btn {

  .select {
    width: 98px;
    height: 32px;
    cursor: pointer;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    background-color: #fff4f4;

    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .keep {
    width: 98px;
    height: 32px;
    margin: 0 10px 0 8px;
    cursor: pointer;
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

.selectBox1 {
  text-align: right;

  .headCnt {
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  button {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
}

.smsTest {
  .test {
    font-size: 14px;

    // height: 32px;
    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
      width: 98px;
      height: 32px;
      cursor: pointer;
    }

    .ipt {
      width: 224px;
      // margin: 0 0px 0 8px;
      vertical-align: top;
    }

    .sendTest {
      width: 106px;
      margin-left: 16px;
      padding: 5px 12px;
      border: 1px solid #fe4d45;
      background-color: #fff;
      color: #fe4d45;

      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45 !important;
      }

      &:active {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }

    .record {
      margin: 0 24px 0 8px;
      color: #333333;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #cccccc;
      background-color: #fff;

      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }

    .record1 {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
      font-size: 14px;
      border-radius: 3px;
      width: 114px;
    }
  }

  .info {
    width: 600px;
    margin-top: 12px;
    line-height: 22px;
    font-size: 13px;
    color: #999;
    background: #FFFAEE;
    padding: 12px;
    color: #333;
    position: relative;

    p {
      margin: 0px;
      line-height: 25px;
      padding-left: 18px;
    }

    .warning-icon {
      color: #ffb95e;
      font-size: 16px;
      position: absolute;
      left: 10px;
      top: 18px;
    }
  }
}



.dialog-wrapper {
  .item {
    margin: 8px 0;

    .item-title {
      width: 200px;
    }

    .input {
      display: inline-block;
      vertical-align: middle;
      width: 330px;
    }
  }

  .remarks {
    // margin-top: 20px;
    width: 400px;
    // height: 44px;
    background: #fafafa;
    opacity: 1;
    line-height: 20px;
  }

  .remarksOne {
    padding: 10px;
    margin-top: 20px;
    width: 400px;
    // height: 80px;
    background: #fafafa;
    opacity: 1;

    // line-height: 44px;
    .boxText {
      // float: left;
      margin: -14px 0 0 20px;
    }

    .icon_i {
      display: inline-block;
      // position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #ffb95e;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      line-height: 14px;
      font-weight: bold;
      // top: 3px;
      // left: 10px;
    }
  }
}

.message-zindex {
  z-index: 99999 !important;
}
.setName{
 position: absolute;
 right:45px;
 top:0px;
 color: #a585ea;
 cursor: pointer;
 &:hover{
   color: #fe4d45;
 }
}
.name-wrap{
  display: flex;
  align-items: center;
  white-space: nowrap;
  &-input{
    width: 346px;
    /deep/.el-input__inner{
      padding-right: 50px !important;
    }
  }
  &-setName{
    color: #7f85e9;
    cursor: pointer;
    margin-left: 8px;
  }
}
</style>